import React, { useState, useRef } from "react";
// import { jwtDecode } from "jwt-decode";
import { redirect, useNavigate } from "react-router-dom";
import "./login.css";
import axios from "axios";
// import env from "react-dotenv";

const Login = () => {
  const [useremail, setUserEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errMessage, setErrMessage] = useState(false);

  const ref1 = useRef("");
  const ref2 = useRef("");

  const reset = () => {
    ref1.current.value = "";
    ref2.current.value = "";
    setUserEmail("");
    setPassword("");
  };
  const nav = useNavigate();
  const handleLogin = async () => {

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/login`,
        {
          userEmail: useremail,
          userPassword: password,
        }
      );
      
      // const token = response.data;
      // const ans = isValidToken(token)
      // const token1 = jwtDecode(token)
      //// console.log("Here are the results ", token1)
      if (response.status === 200) {
        sessionStorage.setItem("token", response.data);
        setErrMessage(false);
        nav("/");
      } else {
        //// console.log("I am in the wrong result")
        setErrMessage(true);
        reset();
      }
    } catch (error) {
      console.error("Login failed:", error);
      setErrMessage(true);
    }
  };

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <div
        style={{
          height: "100vh",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className="form_container">
          <h2>PAR Admin Panel</h2>
          <span className="abc">
            <div>
              <label htmlFor="email">Email</label>
              <input
                ref={ref1}
                type="email"
                name="username"
                value={useremail}
                onChange={(e) => setUserEmail(e.target.value)}
                placeholder="Enter your email"
                required
              />
            </div>
            <div>
              <label htmlFor="password">Password</label>
              <input
                required
                ref={ref2}
                type="password"
                name="password"
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
              />
            </div>
            <button onClick={handleLogin}>Log In</button>
            {errMessage && (
              <>
                <div
                  style={{
                    border: "1px solid red",
                    backgroundColor: "red",
                    borderRadius: "3px",
                  }}
                >
                  <p
                    style={{
                      textAlign: "center",
                      color: "white",
                      padding: "10px, 10px,10px,10px",
                    }}
                  >
                    Oops! Incorrect email or password.
                  </p>
                </div>
              </>
            )}
            <span></span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default Login;
